import { GridRowId } from '@mui/x-data-grid-premium';

export type ExtendedGridRowSelectionModel = {
  ids: GridRowId[];
  rowLookup: Record<string, any>;
};

export const normalizeRowSelectionModel = (
  rowSelectionModel: ExtendedGridRowSelectionModel,
): ExtendedGridRowSelectionModel => {
  return {
    ids: rowSelectionModel.ids ?? [],
    rowLookup: rowSelectionModel.rowLookup ?? {},
  };
};
